import { useMutation, useQuery } from '@tanstack/react-query';
import cteXmlApi from '../api/cte';
import type { XmlCteFilters, XmlCteStats } from '../types/cte';
import { logError } from '../utils/clientLog';

// Hook para buscar XML de CTes
export function useXmlCtes(filters: XmlCteFilters = {}, page = 1, pageSize = 50) {
  return useQuery({
    queryKey: ['xmlCtes', filters, page, pageSize],
    queryFn: () => cteXmlApi.getXmlCtes(filters, page, pageSize),
    staleTime: 30000, // 30 segundos
  });
}

// Hook para estatísticas dos XML de CTes
export function useXmlCteStats(filters: XmlCteFilters = {}) {
  const { data: response, ...rest } = useXmlCtes(filters, 1, 1000); // Buscar mais dados para estatísticas
  
  const xmlCtes = response?.data.data || [];
  const stats: XmlCteStats = {
    total: response?.data.summary?.totalXmls || xmlCtes.length || 0,
    valorTotal: response?.data.summary?.totalValue || xmlCtes.reduce((sum, item) => sum + (item.valorTotal || 0), 0) || 0,
    ultimaAtualizacao: new Date().toISOString(),
  };

  return { data: stats, ...rest };
}

// Hook para baixar XML de CTe
export function useBaixarXmlCte() {
  return useMutation({
    mutationFn: (cteId: number) => cteXmlApi.baixarXml(cteId),
    onError: (error: Error) => {
      logError('Erro ao baixar XML do CTe:', error);
    },
  });
}

// Hook para gerar DACTE PDF
export function useGerarDacteCte() {
  return useMutation({
    mutationFn: (cteId: number) => cteXmlApi.gerarDacte(cteId),
    onError: (error: Error) => {
      logError('Erro ao gerar DACTE do CTe:', error);
    },
  });
}